import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { categories } from '@/mocks/sites';

export default function Hero() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    const matched = categories.find((c) =>
      c.name.includes(query.trim()) || c.description.includes(query.trim())
    );
    if (matched) {
      window.REACT_APP_NAVIGATE(`/category/${matched.slug}`);
    }
  };

  const popularTags = ['百度', '淘宝', '知乎', 'B站', '京东', '微博', '抖音', 'GitHub'];

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20network%20connections%20with%20soft%20gradient%20background%2C%20clean%20minimalist%20design%20with%20interconnected%20nodes%20and%20lines%2C%20light%20airy%20atmosphere%20with%20subtle%20texture%2C%20modern%20technology%20aesthetic%2C%20soft%20neutral%20warm%20tones%20with%20hints%20of%20teal%2C%20digital%20navigation%20concept%2C%20editorial%20quality&width=1600&height=900&seq=hero-bg-nav-01&orientation=landscape"
          alt="蓝色导航在线 - 精准网址导航"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <div className="mb-3">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-sm text-background-50">
            <i className="ri-sparkling-line text-xs"></i>
            精选 40+ 优质网站，持续更新中
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          蓝色导航在线
        </h1>
        <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
          汇聚海量优质网站资源，分类清晰、访问便捷。让每一次上网都高效而有价值。
        </p>

        <form onSubmit={handleSearch} className="flex items-center gap-2 max-w-lg mx-auto mb-8">
          <div className="flex-1 relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
            </div>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t('search')}
              className="w-full pl-10 pr-4 py-3.5 rounded-full bg-background-50 border-0 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-primary-300 transition-all"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('searchBtn')}
          </button>
        </form>

        <div className="flex items-center justify-center gap-2 flex-wrap">
          <span className="text-xs text-background-50/60 whitespace-nowrap">热门搜索：</span>
          {popularTags.map((tag) => (
            <button
              key={tag}
              onClick={() => {
                setQuery(tag);
              }}
              className="px-3 py-1 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-xs text-background-50 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}